<template>
  <div class="allBox userCenterList footerPosition">
    <div class="mianbaoxie">
      <menberMenu :tit-names="titNames" :tit-urls="titUrls"></menberMenu>
    </div>
    <div class="mainBox">
      <div class="editCont">
        <div class="content" >
          <div class="contTitle"><label class="titleLeft"><span class="fa fa-serviceTitle marR5 colGray9 font16"></span><b >Service evaluation</b></label></div>
          <div style="padding:20px" v-if="page!=2">
              <div style="font-size:14px">
                 <b class="colBrack marR30">Are you satisfied with our service this month?</b>
                 <a class="marR30" :class="rate==0?'colBlue bold':'colGray6'" @click="clkRate(0)"><span class="fa fa-handsUp marR5" style="margin-top:-2px;cursor:pointer;" ></span>Satisfied</a>
                 <a class="marL30" :class="rate==1?'colBlue bold':'colGray6'" @click="clkRate(1)"><span class="fa fa-handsDown marR5" style="margin-top:-2px;cursor:pointer;" ></span>Unsatisfied</a>
              </div>
              <div style="font-size:14px;margin-top:20px" v-if="rate==1">
                  <ul class="StarEva">
                     <li>
                       <b>Customer service</b>
                       <label class="starSetAll">
                         <span class="fa" :class="StarCustomerNum==1||StarCustomerNum==2||StarCustomerNum==3||StarCustomerNum==4||StarCustomerNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarCustomer(1)"></span>
                         <span class="fa" :class="StarCustomerNum==2||StarCustomerNum==3||StarCustomerNum==4||StarCustomerNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarCustomer(2)"></span>
                         <span class="fa" :class="StarCustomerNum==3||StarCustomerNum==4||StarCustomerNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarCustomer(3)"></span>
                         <span class="fa" :class="StarCustomerNum==4||StarCustomerNum==5?'fa-star colYellow2':'fa-starline colGray9'"  @click="clkStarCustomer(4)"></span>
                         <span class="fa" :class="StarCustomerNum==5?'fa-star colYellow2':'fa-starline colGray9'"  @click="clkStarCustomer(5)"></span>
                       </label>
                      </li>
                     <li><b>Limitation</b>
                       <label class="starSetAll">
                         <span class="fa" :class="StarAgingNum==1||StarAgingNum==2||StarAgingNum==3||StarAgingNum==4||StarAgingNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarAging(1)"></span>
                         <span class="fa" :class="StarAgingNum==2||StarAgingNum==3||StarAgingNum==4||StarAgingNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarAging(2)"></span>
                         <span class="fa" :class="StarAgingNum==3||StarAgingNum==4||StarAgingNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarAging(3)"></span>
                         <span class="fa" :class="StarAgingNum==4||StarAgingNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarAging(4)"></span>
                         <span class="fa" :class="StarAgingNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarAging(5)"></span>
                       </label>
                     </li>
                     <li><b>Others</b>
                       <label class="starSetAll">
                         
                         <span class="fa" :class="StarOtherNum==1||StarOtherNum==2||StarOtherNum==3||StarOtherNum==4||StarOtherNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarOther(1)" ></span>
                         <span class="fa" :class="StarOtherNum==2||StarOtherNum==3||StarOtherNum==4||StarOtherNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarOther(2)"></span>
                         <span class="fa" :class="StarOtherNum==3||StarOtherNum==4||StarOtherNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarOther(3)"></span>
                         <span class="fa" :class="StarOtherNum==4||StarOtherNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarOther(4)"></span>
                         <span class="fa" :class="StarOtherNum==5?'fa-star colYellow2':'fa-starline colGray9'" @click="clkStarOther(5)"></span>
                       </label>
                     </li>
                  </ul>
                  <div class="cl"></div>
                  <div style="font-size:14px;margin-top:20px">
                  <textarea class="textarea" rows="3" cols="20" placeholder="May I have your valuable Suggestions and comments?" v-model="textareaText" @blur="blurText"></textarea>
                  <p class="colRed" v-if="isText"> Maximum is 500 characters</p>
                </div>
              </div>
              <div style="margin:30px 0 10px 0;text-align:center"><a class="btnSubmit font14 TextC" @click="clkSub">Submit</a></div> 
          </div>
          <div style="padding:50px 0;text-align:center"  v-if="page==2">
            <p class="fa fa-sccessful colGreen" style="font-size:34px;padding-bottom:10px"></p>
            <p class="bold font16">Thank you for your comments!</p> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from "vue";
import { getCookie } from "../../../ask/cookiejs";
import { post, fetch, Del, put } from "../../../ask/axios";
import menberMenu from '../../../components/userCenter/public/menberPageMenu.vue';

export default {
  components: {menberMenu},
  data (){
    return {
      api: {
        url: "",
        param: "",
        data:"",
        response: {},
        message: ""
      },

      titNames: 'Service evaluation',
      titUrls: ',',

       rate:0, //是否满意
      
      StarCustomerNum:null, //客服服务
      StarAgingNum:null, //舱位时效
      StarOtherNum:null,//其他星星

      textareaText:'',//建议

     page:null,//显示评价成功还是待评价页面

     isText:false,

    }
  },
  created(){ //创建前
   this.page = this.$route.query.page
  },
  mounted(){ //载入dom后周期函数
    
  },
  watch:{

  },
  computed:{ //计算属性

  },
  //方法
  methods: {
    //服务是否满意
    clkRate(id){
      switch (id){
        case 0:
          this.rate=0
        break;
        case 1:
          this.rate=1
          break;
        default:
          this.rate=null
          break;
      }
    },
    //客服服务星星点亮
    clkStarCustomer(id){
      switch (id){
        case 1:
          this.StarCustomerNum=1
        break;
        case 2:
          this.StarCustomerNum=2
          break;
        case 3:
          this.StarCustomerNum=3
          break;
        case 4:
          this.StarCustomerNum=4
        break;
        case 5:
          this.StarCustomerNum=5
          break;
        default:break;
      }
    },
    //舱位时效
     clkStarAging(id){
      switch (id){
        case 1:
          this.StarAgingNum=1
        break;
        case 2:
          this.StarAgingNum=2
          break;
        case 3:
          this.StarAgingNum=3
          break;
        case 4:
          this.StarAgingNum=4
        break;
        case 5:
          this.StarAgingNum=5
          break;
        default:break;
      }
    },
     //其他
     clkStarOther(id){
      switch (id){
        case 1:
          this.StarOtherNum=1
        break;
        case 2:
          this.StarOtherNum=2
          break;
        case 3:
          this.StarOtherNum=3
          break;
        case 4:
          this.StarOtherNum=4
        break;
        case 5:
          this.StarOtherNum=5
          break;
        default:break;
      }
    },
    //验证建议是否超过500字符
    blurText(){
      if(this.textareaText.length > 500){
        this.isText=true
      }else{
        this.isText=false
      }
    },

    //提交评价按钮
    clkSub(){
       if(this.rate==1){
          if((!this.StarCustomerNum && !this.StarAgingNum && !this.StarOtherNum) || !this.textareaText){
            this.$confirm( 'Please kindly give us your best suggestions in one of the three items: customer service, limitation and others.','',  {
              customClass:'custom-message-box', //自定义添加Class
              confirmButtonText: 'Confirm',
              cancelButtonText: '',
              cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
              closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
              showCancelButton:false,//去掉取消按钮
              showClose:false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {
              
            }).catch(() => {
 
            });
            return false
          }else{
           this.serviceApi()
          }
          
       }else{
           this.serviceApi()
       }
    },
    //提交服务评价接口
    serviceApi(){
        let that=this
                  
        if(this.isText){ //验证建议是否超过500字符
            return false
        }

        this.api.param={
          Satisfied:that.rate, //是否满意  //0：满意，1：不满意
          Content:that.textareaText, //评价内容
        }

        //评价项目和评价星级 
      let starList=[
        {ItemValue:1,ItemScore:this.StarCustomerNum},
        {ItemValue:2,ItemScore:this.StarAgingNum},
        {ItemValue:3,ItemScore:this.StarOtherNum},
      ]
      if(that.rate==1){
         this.api.param.EvalItemList=starList  //评价项目
      }else{
        this.api.param.EvalItemList=null
      }
      

      // this.api.url=this.$api02+"/api/EbayCustomer/ServiceEvaluation/Add";
      this.api.url=this.$api04 + "/Basics/api/ServiceEvaluation/Add";
      post(this.api.url,this.api.param).then(function (res) {
        if(res.IsOK){
           that.page=2
           that.$router.push({
              path: "/serviceEvaluation?page=2",
            })  
        }else{
          that.$confirm( 'failed!','',  {
              customClass:'custom-message-box', //自定义添加Class
              confirmButtonText: 'Confirm',
              cancelButtonText: '',
              cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
              closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
              showCancelButton:false,//去掉取消按钮
              showClose:false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {
              
            }).catch(() => {

            });
        }     
      })
    }
    


  }
}

</script>
<style type="text/css" rel="stylesheet" scoped="scoped">
  /* @import "../../../../static/css/userCenterList.css"; */
  @import "../../../assets/css/userCenterCss.css";

  .StarEva li{float:left;margin-right:80px}
  .starSetAll{margin-left:5px;}
  .starSetAll span{cursor:pointer;margin:-3px 1px 0 1px;}

  .textarea{resize:none;width:99%;}
 

</style>



// WEBPACK FOOTER //
// src/components/userCenter/myInfo/serviceEvaluation.vue